<template>
  <div class="py-2 handle__transition">
    <b-container
      fluid
      class="col-sm-11 col-lg-8 border-secondary mx-auto border__div px-0 pt-0 pb-4 mb-2"
    >
      <b-tabs
        active-nav-item-class="font-weight-bold text-white bg-secondary border-secondary rounded-0 no__hover"
        active-tab-class="font-weight-bold text-success"
        content-class="mt-3 "
        nav-class="text-secondary font-weight-bold border-bottom border-secondary px-0 nav_border"
        fill
        no-key-nav
        no-nav-style
      >
        <b-tab title="Dati Anagrafici" active>
          <div>
            <div class="col-10 mx-auto" v-if="!msg">
              <b-overlay :show="loading" rounded="sm" spinner-variant="secondary">
                <b-form @submit="onSubmit">
                  <b-row class="my-1 justify-content-around">
                    <b-col sm="4" class="align-self-center text-left text-secondary">
                      <label for="nome" class="text-right">Nome:</label>
                    </b-col>
                    <b-col sm="6">
                      <b-form-input
                        v-model="user.anagrafica.nome"
                        type="text"
                        id="nome"
                        :placeholder="user.anagrafica.nome"
                        class="my-2"
                        :disabled="disable"
                      ></b-form-input>
                    </b-col>
                  </b-row>
                  <b-row class="my-1 justify-content-around">
                    <b-col sm="4" class="align-self-center text-left text-secondary">
                      <label for="nome" class="text-right">Cognome:</label>
                    </b-col>
                    <b-col sm="6">
                      <b-form-input
                        v-model="user.anagrafica.cognome"
                        type="text"
                        id="cognome"
                        :placeholder="user.anagrafica.cognome"
                        class="my-2"
                        :disabled="disable"
                      ></b-form-input>
                    </b-col>
                  </b-row>
                  <b-row class="my-1 justify-content-around">
                    <b-col sm="4" class="align-self-center text-left text-secondary">
                      <label for="nome" class="text-right">Regione:</label>
                    </b-col>
                    <b-col sm="6">
                      <!-- <b-form-input
                        v-model="user.anagrafica.regione"
                        type="text"
                        id="regione"
                        :placeholder="user.anagrafica.regione"
                        class="my-2"
                        :disabled="disable"
                      ></b-form-input>-->
                      <b-form-select
                        id="regione"
                        class="my-2"
                        :placeholder="user.anagrafica.regione"
                        v-model="user.anagrafica.regione"
                        :disabled="disable"
                        :options="regioni"
                        @change="getProvincie"
                      ></b-form-select>
                    </b-col>
                  </b-row>
                  <b-row class="my-1 justify-content-around">
                    <b-col sm="4" class="align-self-center text-left text-secondary">
                      <label for="nome" class="text-right">Provincia:</label>
                    </b-col>
                    <b-col sm="6">
                      <b-form-input
                        v-if="disable"
                        v-model="user.anagrafica.provincia"
                        type="text"
                        id="provincia"
                        :placeholder="user.anagrafica.provincia"
                        class="my-2"
                        :disabled="disable"
                      ></b-form-input>
                      <b-form-select
                        v-else
                        id="provincia"
                        :placeholder="user.anagrafica.provincia"
                        class="my-2"
                        :disabled="disable"
                        :options="province"
                        @change="getComuni"
                      ></b-form-select>
                    </b-col>
                  </b-row>
                  <b-row class="my-1 justify-content-around">
                    <b-col sm="4" class="align-self-center text-left text-secondary">
                      <label for="nome" class="text-right">Comune:</label>
                    </b-col>
                    <b-col sm="6">
                      <!-- <b-form-input
                        v-model="user.anagrafica.comune"
                        type="text"
                        id="comune"
                        :placeholder="user.anagrafica.comune"
                        class="my-2"
                        :disabled="disable"
                      ></b-form-input>-->
                      <b-form-select
                        id="comune"
                        class="my-2"
                        v-model="user.anagrafica.comune"
                        :disabled="disable"
                        :placeholder="user.anagrafica.comune"
                      >
                        <b-form-select-option
                          v-for="(comune, ind) in comuni"
                          :key="ind"
                          :value="comune.comune"
                        >{{ comune.comune }}</b-form-select-option>
                      </b-form-select>
                    </b-col>
                  </b-row>
                  <b-row class="my-1 justify-content-around">
                    <b-col sm="4" class="align-self-center text-left text-secondary">
                      <label for="nome" class="text-right">Indirizzo:</label>
                    </b-col>
                    <b-col sm="6">
                      <b-form-input
                        v-model="user.anagrafica.indirizzo"
                        type="text"
                        id="indirizzo"
                        :placeholder="user.anagrafica.indirizzo"
                        class="my-2"
                        :disabled="disable"
                      ></b-form-input>
                    </b-col>
                  </b-row>
                  <b-row class="my-1 justify-content-around">
                    <b-col sm="4" class="align-self-center text-left text-secondary">
                      <label for="nome" class="text-right">Telefono:</label>
                    </b-col>
                    <b-col sm="6">
                      <b-form-input
                        v-model="user.anagrafica.telefono"
                        type="text"
                        id="telefono"
                        :placeholder="user.anagrafica.telefono"
                        class="my-2"
                        :disabled="disable"
                      ></b-form-input>
                    </b-col>
                  </b-row>
                  <b-row class="my-1 justify-content-around">
                    <b-col sm="4" class="align-self-center text-left text-secondary">
                      <label for="nome" class="text-right">Codice Fiscale:</label>
                    </b-col>
                    <b-col sm="6">
                      <b-form-input
                        v-model="user.anagrafica.cf"
                        type="text"
                        id="cf"
                        :placeholder="user.anagrafica.cf"
                        class="my-2 text-uppercase"
                        :disabled="disable"
                      ></b-form-input>
                    </b-col>
                  </b-row>

                  <!-- <div v-if="error"> -->
                  <p v-if="error" class="text-danger">{{ error }}</p>
                  <!-- </div> -->

                  <span
                    class="text-secondary edit__link pt-3"
                    v-if="this.disable"
                    @click="toggleEdit"
                  >Modifica</span>
                  <div v-else>
                    <b-button
                      type="button"
                      variant="outline-primary font-weight-bold mx-2"
                      @click="toggleEdit"
                    >Annulla</b-button>
                    <b-button type="submit" variant="primary font-weight-bold mx-2">Salva</b-button>
                  </div>
                </b-form>
              </b-overlay>
            </div>
            <p v-else class="text-primary">{{ msg }}</p>
          </div>
        </b-tab>
        <b-tab title="Parametri Vitali" class="nav_border">
          <parametri-vitali v-on:add-storico="newStorico($event)" />
        </b-tab>
      </b-tabs>
    </b-container>
    <!-- <div class="pt-3 d-flex flex-wrap col-8 mx-auto px-0 justify-content-between"> -->
    <transition-group
      tag="div"
      name="list"
      id="storici"
      class="pt-3 d-flex flex-wrap col-9 mx-auto px-0 justify-content-between"
    >
      <storico-parametro
        v-for="(storico, ind) in storicoList"
        :key="ind"
        :parametro="storico"
        v-on:remove-storico="hideStorico($event)"
      />
    </transition-group>
    <!-- </div> -->
  </div>
</template>

<script>
import ParametriVitali from "./ParametriVitali";
import StoricoParametro from "./StoricoParametro";
export default {
  name: "anagrafica-paziente",
  props: ["utente"],
  components: {
    ParametriVitali,
    StoricoParametro
  },
  data() {
    return {
      user: this.utente,
      disable: true,
      msg: null,
      error: false,
      loading: false,
      storicoList: [],
      regioni: null,
      province: null,
      comuni: null
    };
  },
  watch: {},
  computed: {
    isLista: function() {
      return this.storicoList.length > 0;
    }
  },
  methods: {
    toggleEdit(e) {
      e.preventDefault();
      // console.log("clck");
      this.disable = !this.disable;
    },
    onSubmit(evt) {
      evt.preventDefault();
      !this.validate() && this.sendForm();
    },
    validate() {
      var check = Object.keys(this.user.anagrafica).some(val => {
        val != "cellulare" && this.user.anagrafica[val] == null;
      });
      if (check) {
        this.error = "nessun campo può essere vuoto";
      }
      return check;
    },
    sendForm() {
      this.loading = true;
      var url = process.env.VUE_APP_VERSION + this.user.role;
      this.$axios
        .put(url, this.user.anagrafica)
        .then(() => {
          this.loading = false;
          this.msg = "Operazione effettuata con successo!";
          var self = this;
          setInterval(function() {
            self.$router.go();
          }, 1000);
        })
        .catch(err => {
          this.error = err.response;
          this.loading = false;
        });
    },
    newStorico(parametro) {
      if (!this.storicoList.includes(parametro)) {
        this.storicoList.push(parametro);
      }
    },
    hideStorico(parametro) {
      // console.log("Hide", parametro);
      if (this.storicoList.includes(parametro)) {
        // console.log("before", this.storicoList);
        this.storicoList.splice(this.storicoList.indexOf(parametro), 1);
        // console.log("after", this.storicoList);
      }
    },
    getRegioni() {
      var url = process.env.VUE_APP_VERSION + "regioni";
      this.$axios
        .get(url)
        .then(res => {
          this.regioni = res.data.data;
          this.getProvincie();
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    getProvincie() {
      var url = process.env.VUE_APP_VERSION + "province";
      if (this.user.anagrafica.regione) {
        url =
          process.env.VUE_APP_VERSION +
          "province/" +
          this.user.anagrafica.regione;
      }

      this.$axios
        .get(url)
        .then(res => {
          this.province = res.data.data;
          this.getComuni();
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    getComuni() {
      var url = process.env.VUE_APP_VERSION + "comuni";
      if (this.user.anagrafica.regione) {
        url =
          process.env.VUE_APP_VERSION +
          "comuni/regioni/" +
          this.user.anagrafica.regione;
        if (this.user.anagrafica.provincia) {
          url =
            process.env.VUE_APP_VERSION +
            "comuni/province/" +
            this.user.anagrafica.provincia;
        }
      }
      this.$axios
        .get(url)
        .then(res => {
          this.comuni = res.data.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    }
  },
  created() {
    this.getRegioni();
    // this.getProvincie();
    // this.getComuni();
  }
};
</script>
<style scoped>
.list-enter-active,
.list-leave-active,
.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.list-enter {
  opacity: 0;
  transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0) scaleY(1);
}

.list-leave-active {
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: scaleY(0);
  transform-origin: center top;
}
.handle__transition {
  /* transition: all 0.4ms; */
}
</style>
